export const initAlertDialog = () => {
    document.querySelectorAll(".alert-dialog").forEach(alertDialog => {
        const closeButton = alertDialog.querySelector(".close-button")
        closeButton && closeButton.addEventListener("click", () => {
            alertDialog.classList.remove("active");
        })
    })
}